import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { APIResponse } from '../interfaces/api.interface';
import {
  BulkImportResponse,
  TemplateSample,
  TemplateSampleCreate,
  TemplateSampleUpdate,
} from '../interfaces/sample.interface';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class TemplateSampleService {
  public constructor(private readonly api: ApiService) {}

  public get(organisationId: string, templateId: string): Observable<APIResponse<TemplateSample[]>> {
    return this.api.get<APIResponse<TemplateSample[]>>(
      `organisations/${organisationId}/templates/${encodeURIComponent(templateId)}/samples`,
    );
  }

  public getOne(
    organisationId: string,
    templateId: string,
    sampleId: string,
  ): Observable<TemplateSample> {
    const path = `organisations/${organisationId}/templates/${templateId}/samples/${sampleId}`;

    return this.api.get<TemplateSample>(path);
  }

  public create(
    organisationId: string,
    templateId: string,
    sample: TemplateSampleCreate,
  ): Observable<TemplateSample> {
    return this.api.post<TemplateSample, TemplateSampleCreate>(
      `organisations/${organisationId}/templates/${templateId}/samples`,
      sample,
    );
  }

  public update(
    organisationId: string,
    templateId: string,
    sampleId: string,
    sample: TemplateSampleUpdate,
  ): Observable<TemplateSample> {
    return this.api.put<TemplateSample, TemplateSampleUpdate>(
      `organisations/${organisationId}/templates/${templateId}/samples/${sampleId}`,
      sample,
    );
  }

  public delete(
    organisationId: string,
    templateId: string,
    sampleId: string,
  ): Observable<TemplateSample> {
    return this.api.delete(
      `organisations/${organisationId}/templates/${templateId}/samples/${sampleId}`,
    );
  }

  public bulkImport(
    organisationId: string,
    templateId: string,
    file: File,
  ): Observable<BulkImportResponse> {
    const formData = new FormData();
    formData.append('file', file);

    return this.api.post<BulkImportResponse, FormData>(
      `organisations/${organisationId}/templates/${templateId}/samples/bulk`,
      formData,
    );
  }
}
